<template>
    <div>
        <form data-vv-scope="certificate">
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block" class="p-1">
                    <MultiselectCustom endpoint="admissions/international-certificate-types/"
                                       name="type"
                                       v-validate="'required'"
                                       :placeholder="`${ $t('type') }*`"
                                       v-model="certificate.type"/>
                    <ValidateText field="type" scope="certificate" :error="errors"/>
                </div>
            </div>
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block" class="p-1">
                    <MultiselectCustom endpoint="common/language-levels/"
                                       name="proficiency"
                                       v-validate="'required'"
                                       :placeholder="`${ $t('proficiency') }*`"
                                       v-model="certificate.proficiency"/>
                    <ValidateText field="proficiency" scope="certificate" :error="errors"/>
                </div>
                <div :class="classForDOM.block" class="p-1">
                    <MultiselectCustom endpoint="organizations/languages/"
                                       name="language"
                                       v-validate="'required'"
                                       :placeholder="`${ $t('language') }*`"
                                       v-model="certificate.language"/>
                    <ValidateText field="language" scope="certificate" :error="errors"/>
                </div>
            </div>
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block">
                    <vs-input :label-placeholder="`${ $t('score') }`"
                              v-validate="'required|between:1,150'"
                              name="score"
                              v-model="certificate.score"
                              class="mt-8 flex-auto p-1 w-full"/>
                    <ValidateText field="score" scope="certificate" :error="errors"/>
                </div>
                <div :class="classForDOM.block">
                    <vs-input :label-placeholder="`${ $t('number') }`"
                              v-validate="'required'"
                              name="number"
                              v-model="certificate.number"
                              class="mt-8 flex-auto p-1 w-full"/>
                    <ValidateText field="number" scope="certificate" :error="errors"/>
                </div>
            </div>
            <div :class="classForDOM.parent">
                <div :class="classForDOM.block">
                    <DatepickerCustom v-model="certificate.issued_at"
                                      name="issued_at"
                                      v-validate="'required'"
                                      :placeholder="`${ $t('issued_at') }*`"/>
                    <ValidateText field="issued_at" scope="certificate" :error="errors"/>
                </div>
            </div>
            <template v-if="file_upload_limitation">
                <span class="text-base font-medium pt-4 block pl-2">{{ $t('upload_the_required_documents') }}*</span>
                <span v-if="!certificate.files.length" class="pl-2 text-danger" >{{ $t('please_add_files') }}</span>
                <div :class="classForDOM.parent">
                    <vs-upload
                        :text="$t('upload_file')"
                        :action="'common/upload/'"
                        :disabled="false"
                        @on-success="setCertificateFiles"
                        @prev-delete="removeCertificateFile"
                        :single-upload="true"
                        :firstFiles="certificate.files"
                        :automatic="true"
                        :max-size="file_upload_limitation['max_file_size']"
                        :fileName="'path'"
                    />
                </div>
            </template>
        </form>
        <vs-button type="relief" @click="validateForm">{{ $t('saveInternationalCertificate') }}</vs-button>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import DatepickerCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/DatepickerCustom";
export default {
    name: "InternationalCertificateForm",
    props: {
        profileUid: {
            type: String,
            required: true,
        },
        file_upload_limitation: {
            type: Object,
            required: true,
        },
        data: {
            type: Object,
            default: null,
        }
    },
    components: {
        MultiselectCustom,
        ValidateText,
        DatepickerCustom
    },
    data(){
        return {
            certificate: {
                profile: this.profileUid,
                type: '',
                proficiency: '',
                language: '',
                score: '',
                issued_at: '',
                number: '',
                files: [],
                uid: null,
            },
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            },
        }
    },
    methods: {
        setCertificateFiles(response){
            if (!this.certificate.files) this.certificate.files = [];
            if (this.certificate.files.findIndex(({ name }) => name === response[0].name)){
                const firstFiles = this.certificate.files.filter((i) => i.firstFile || i.name !== response[0].name);
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.certificate.files = firstFiles.concat(newFiles);
            } else {
                this.certificate.files = this.certificate.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        async removeCertificateFile({ file, done }){
            this.certificate.files = await this.certificate.files.filter((item) => item.response.uid !== file.response.uid);
            done();
        },
        validateForm(){
            return this.$validator.validateAll('certificate').then(async (result) => {
                if (result && this.certificate.files.length) {
                    // Делаю запросы на сохранение и пропускаю клиента на следующий шаг
                    await this.saveCertificate();
                    return true
                }
                else
                    return false

            })
        },
        async saveCertificate(){
            try {
                this.$vs.loading();

                const newCertificate = this.certificate?.uid;

                const clone = { ...this.certificate };

                clone.files = clone.files.map(f => f.response.uid);

                const response = (await this.$http[newCertificate ? 'patch' : 'post'](
                    `admissions/international-certificates/${ newCertificate ? newCertificate + '/' : '' }`,
                    clone
                )).data

                this.$emit('setObjectCertificate', response)
            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        }
    },
    created() {
        if(this.data){
            for (let key in this.certificate){
                if(key === 'files'){
                    this.certificate.files = this.data.files.map(f => {
                        return {
                            ...f,
                            firstFiles: true,
                            response: f,
                        }
                    })
                } else {
                    this.certificate[key] = this.data[key];
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
